exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-card .mat-card-title{display: block; padding:0 0 20px 0; margin:0;}\n.mat-card .mat-card-title h4{margin-bottom: 0;}\n.mat-card-content{font-size: 14px;}\n.settings_page ul li{margin:0;}\n.settings_page ul li b{padding-top:5px; display:block;}\n.table td, .table th{padding:1rem;}\ntable{border-bottom: 1px solid #ddd; margin:0;}\n.extra_padd{padding:20px 10px;}\n.mat-card{padding:20px 14px;}\n.mt_5minus{margin-top:-5px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/supplier/profile/settings/settings.component.css
// module id = ../../../../../src/app/supplier/profile/settings/settings.component.css
// module chunks = 39